import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ContactUsModal from "../ContactUsButton/ContactUsModal";
import "./Footer.css";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false); // modal state

  const handleLocationClick = () => {
    if (location.pathname !== "/") {
      navigate("/", { replace: false });
      setTimeout(() => {
        document
          .getElementById("locations")
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document
        .getElementById("locations")
        ?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const links = [
    { text: t("navbar.items.about"), path: "/about" },
    { text: t("navbar.items.getStarted"), path: "/get-started" },
    { text: t("navbar.items.outOfHome"), path: "/out-of-home" },
    { text: t("navbar.items.contact"), path: "/contact" },
  ];

  // Secondary, lighter-weight row: the 4 city pages + 3 service pages,
  // none of which are in the main nav (kept deliberately light) or
  // reachable from anywhere else on most pages otherwise.
  const secondaryLinks = [
    { text: t("footer.cities.brossard"), path: "/affichage-numerique-brossard" },
    { text: t("footer.cities.chateauguay"), path: "/affichage-numerique-chateauguay" },
    { text: t("footer.cities.valleyfield"), path: "/affichage-numerique-valleyfield" },
    { text: t("footer.cities.beauharnois"), path: "/affichage-numerique-beauharnois" },
    { text: t("footer.services.affichageNumerique"), path: "/affichage-numerique" },
    { text: t("footer.services.publiciteInterieure"), path: "/publicite-interieure" },
    { text: t("footer.services.compagnieMedia"), path: "/compagnie-media" },
  ];

  return (
    <>
      <div className="bg-black text-white d-flex flex-column align-items-center justify-content-center py-5">
        <Container className="d-flex flex-column align-items-center gap-4">
          <div className="desktop-social-links d-flex gap-3">
            <a
              href="https://www.facebook.com/profile.php?id=61583292343959"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook size={30} color="white" />
            </a>
            <a
              href="https://www.instagram.com/drinqofficial/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram size={30} color="white" />
            </a>
          </div>

          <div className="custom-text footer-text d-flex gap-4 flex-wrap justify-content-center">
            {links.map((link, index) => {
              if (link.path === "/contact") {
                return (
                  <span
                    key={index}
                    onClick={() => setShowModal(true)}
                    className="text-light fw-semibold footer-text text-decoration-none"
                    style={{ cursor: "pointer" }}
                  >
                    {link.text}
                  </span>
                );
              }

              if (link.text === "Locations") {
                return (
                  <span
                    key={index}
                    onClick={handleLocationClick}
                    className="text-light fw-semibold footer-text text-decoration-none"
                    style={{ cursor: "pointer" }}
                  >
                    {link.text}
                  </span>
                );
              }

              return (
                <Link
                  key={index}
                  to={link.path}
                  className="text-light fw-semibold footer-text text-decoration-none"
                >
                  {link.text}
                </Link>
              );
            })}
          </div>

          <div className="d-flex flex-column align-items-center gap-2">
            <div
              className="text-light fw-semibold"
              style={{ fontSize: "13px", opacity: 0.6, textTransform: "uppercase", letterSpacing: "0.06em" }}
            >
              {t("footer.networkTitle")}
            </div>
            <div className="d-flex gap-3 flex-wrap justify-content-center">
              {secondaryLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.path}
                  className="text-light text-decoration-none"
                  style={{ fontSize: "13.5px", opacity: 0.75 }}
                >
                  {link.text}
                </Link>
              ))}
            </div>
          </div>

          <div className="text-center text-light fs-6">
            © {new Date().getFullYear()} DRINQ | All Rights Reserved
          </div>
        </Container>
      </div>

      {/* Contact Us Modal */}
      <ContactUsModal
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </>
  );
}
